import React from 'react';
import './FeedFooterShare.css';
import iconPath from "../../../helpers/iconHelper";


const FeedFooterShare = ({total_share}) => {
  const openApp = () => {
    $("#appModal").modal('show');
  }

  return (
    <a href="#" className="post-add-icon inline-items">
        <img style={{width: '30px'}} src={iconPath['FEEDSHARE']} onClick={openApp}/> 
        <span style={{color: 'rgb(136, 136, 142)'}}>{total_share}</span>
    </a>
    
  
  );
};
export default FeedFooterShare;
